import React, { Props } from "react";
import Amplify, { Auth } from "aws-amplify";
import { AmplifyAuthenticator, AmplifySignOut } from "@aws-amplify/ui-react";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import HomeProps from "./../pages/Home";
import { attachProps } from "@ionic/react/dist/types/components/utils";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Component } from "ionicons/dist/types/stencil-public-runtime";
import Cors from "cors";
import { getDecodedToken } from "./Helpers";
import { IUserProps } from "../models/user";
import * as ApiService from "../services/ApiService";
import { IProvider, IProviderType } from "../models/provider";
import { ENV } from "../environments/env";
import { Measurement } from "../components/EMRReadingsComponent";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//DEBUG settings
//const URL_LOCATION: string = "http://localhost:5000";
//
const URL_LOCATION: string = `${ENV.ENDPOINT}`; //"https://health-api-tst.medline.com";

//react-i18next subscribes that component to the i18n instance.
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources: {}, // will be filled dynamically
});

export const loadTranslations = (lang: string, user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
    "Accept": '*/*',
  };
  const URL = `${URL_LOCATION}/api/localization/getTranslations/${lang}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    i18n.addResourceBundle(lang, "translation", response.data, true, true);
    //triggers auto re-render in all components
    i18n.changeLanguage(lang); //every component using t() automatically re-renders in the new language
    i18n.emit("languageChanged", lang);
    return response.data;
  });
}

export const fetchUser = (user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
    "Accept": '*/*',
  };
  const URL = `${URL_LOCATION}/api/user/${user}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const addUser = (user: any, data: IUserProps) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const updateUserAttributes = (user: any, data: IUserProps) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser`;
  return axios({
    url: URL,
    method: "put",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const activateUser = (user: any, data: IUserProps) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser/activateuser/${data.username}`;
  return axios({
    url: URL,
    method: "put",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const deactivateUser = (user: any, data: IUserProps) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const URL = `${URL_LOCATION}/api/CognitoUser/deactivateuser/${data.username}`;
  const URL = `${URL_LOCATION}/api/CognitoUser/AdminRemoveUserFromGroup`;
  return axios({
    url: URL,
    method: "delete",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const getUserCount = (user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/user/userscount`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const getPatientCountReport = (user: any, type: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/report/patientcount?type=` + type;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const uploadReport = (user: any, type: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/report/uploadtosftp?type=` + type;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchUsers = (
  user: any,
  groupId: string,
  pageSize: number,
  pageNum: number,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  searchType: string,
  searchStringType?: string,
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };

  //const jwtDecoded :any = getDecodedAccessToken(`${props.signInUserSession.accessToken.jwtToken}`) ;
  //let groupId = jwtDecoded["cognito:groups"][0];
  let URL = `${URL_LOCATION}/api/CognitoUser/ListUsers?groupcode=${groupId}&type=${searchType}&pageNumber=${pageNum}&pageSize=${pageSize}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}&searchStringType=${searchStringType}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchPatients = (
  user: any,
  groupId: string,
  pageSize: number,
  pageNum: number,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  searchType: string
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedAccessToken(`${props.signInUserSession.accessToken.jwtToken}`) ;
  //let groupId = jwtDecoded["cognito:groups"][0];
  let URL = `${URL_LOCATION}/api/CognitoUser/ListUsers?groupcode=${groupId}&type=${searchType}&pageNumber=${pageNum}&pageSize=${pageSize}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchUserXls = (
  user: any,
  groupId: string,
  pageSize: number,
  pageNum: number,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  searchType: string
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedAccessToken(`${props.signInUserSession.accessToken.jwtToken}`) ;
  //let groupId = jwtDecoded["cognito:groups"][0];
  let URL = `${URL_LOCATION}/api/report/users/xls?groupcode=${groupId}&type=${searchType}`;
  if (pageSize !== null) URL += `&pageNumber=${pageNum}&pageSize=${pageSize}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchReadings = (
  loggedInUser: any,
  groupId: string,
  pageSize: number,
  pageNum: number,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null,
  readingType: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Measurement/ListGroupReadings/${groupId}?pageNumber=${pageNum}&pageSize=${pageSize}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  if (readingType !== null && readingType !== "")
    URL += `&readingType=${readingType}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchGroupReadingsCount = (
  loggedInUser: any,
  groupId: string,
  startDate: string | null,
  endDate: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Measurement/ListGroupReadingsCount/${groupId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchUserReadings = (
  loggedInUser: any,
  userId: string,
  pageSize: number,
  pageNum: number,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedToken(`${loggedInUser.signInUserSession.accessToken.jwtToken}`) ;
  let URL = `${URL_LOCATION}/api/Measurement/ListUserReadings/${userId}?pageNumber=${pageNum}&pageSize=${pageSize}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      //
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};

export const fetchUserReadingsCount = (
  loggedInUser: any,
  groupId: string,
  startDate: string | null,
  endDate: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Measurement/ListUserReadingsCount/${groupId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchLatestUserReadings = (loggedInUser: any, userId: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedToken(`${loggedInUser.signInUserSession.accessToken.jwtToken}`) ;
  const URL = `${URL_LOCATION}/api/Measurement/LatestUserReadings/` + userId;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      //
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};

export const fetchReadingCountWithMethod = (
  loggedInUser: any,
  groupId: string,
  startDate: string | null,
  endDate: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Measurement/readingscountwithmethod/${groupId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};


export const fetchEMRMeasurements = (loggedInUser: any, groupcode: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedToken(`${loggedInUser.signInUserSession.accessToken.jwtToken}`) ;
  const URL = `${URL_LOCATION}/api/Measurement/emrreadings/` + groupcode;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      //
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};


export const postEMRMeasurement = (loggedInUser: any, measurement: Measurement) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/integration/sendobservation`;
  return axios({
    url: URL,
    method: "post",
    data: measurement,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};

export const postEMRMeasurements = (loggedInUser: any, measurements: Measurement[]) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/integration/sendobservations`;
  return axios({
    url: URL,
    method: "post",
    data: measurements,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};

export const fetchProviderTypes = (props: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/CognitoUser/grouptypes`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchUserMeasurement = (props: any, userID: string, providerCode: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/cognitouser/${userID}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchUserProviders = (props: any, userID: string, providerCode: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/cognitouser/ListUserProviders/${userID}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchCycle = (props: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const CancelToken = axios.CancelToken;
  let cancel: () => void;
  const URL = `${URL_LOCATION}/api/measurement/cycle/${provider}`;
  return axios({
    url: URL,
    method: "get",
    cancelToken: new CancelToken((c) => (cancel = c)),
  }).then((response) => {
    return response.data;
  });
};

export const fetchDashboardView = (props: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const CancelToken = axios.CancelToken;
  let cancel: () => void;
  const URL = `${URL_LOCATION}/api/provider/dashboardview/${provider}`;
  return axios({
    url: URL,
    method: "get",
    cancelToken: new CancelToken((c) => (cancel = c)),
  }).then((response) => {
    return response.data;
  });
};

export const fetchBreachMeasurement = (props: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const CancelToken = axios.CancelToken;
  let cancel: () => void;
  const URL = `${URL_LOCATION}/api/measurement/breaches/${provider}`;
  return axios({
    url: URL,
    method: "get",
    cancelToken: new CancelToken((c) => (cancel = c)),
  }).then((response) => {
    return response.data;
  });
};

export const updateBreachNote = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/measurement/updatebreach`;

  return axios({
    url: URL,

    method: "put",

    data: data,
  }).then((response) => {
    return response;
  });
};

export const fetchProviders = (props: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );

  const URL = `${URL_LOCATION}/api/CognitoUser/groups`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};

export const fetchProvider = (user: any, groupId: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };

  const URL = `${URL_LOCATION}/api/CognitoUser/groups/${groupId}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};


export const fetchProviderAndThreshold = (props: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );

  const URL = `${URL_LOCATION}/api/CognitoUser/thresholdgroups`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
};


export const updateThresholds = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/provider/updatethreshold`;

  return axios({
    url: URL,
    method: "put",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const updateUserThresholds = (user: any, data: any, providerCode: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/cognitouser/updatethreshold/${providerCode}`;

  return axios({
    url: URL,
    method: "put",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const updateSelectedUserThresholds = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,

    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/cognitouser`;

  return axios({
    url: URL,

    method: "put",

    data: data,
  }).then((response) => {
    return response;
  });
};

export const addProvider = (user: any, data: IProviderType) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser/addgroup`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};

export const updateProvider = (user: any, data: IProvider) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser/updategroup`;
  return axios({
    url: URL,
    method: "put",
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const activateProvider = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser/activategroup/${data}`;
  return axios({
    url: URL,
    method: "put",
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const deActivateProvider = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/CognitoUser/deactivategroup/${data}`;
  return axios({
    url: URL,
    method: "delete",
    data: data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const fetchGroups = (props: any, pageSize: number, pageNum: number) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL =
    `${URL_LOCATION}/api/CognitoUser/ListGroupsAuthenticated?pageNumber=` +
    pageNum +
    `&pageSize=` +
    pageSize;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const downloadGroupPdf = (
  loggedInUser: any,
  groupId: string,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null,
  readingType: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Report/GroupReadings/${groupId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  if (readingType !== null && readingType !== "")
    URL += `&readingType=${readingType}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const downloadUserPdf = (
  loggedInUser: any,
  userId: string,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Report/UserReadings/${userId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const downloadGroupXls = (
  loggedInUser: any,
  groupId: string,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null,
  readingType: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Report/GroupReadingsXls/${groupId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  if (readingType !== null && readingType !== "")
    URL += `&readingType=${readingType}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const downloadUserXls = (
  loggedInUser: any,
  userId: string,
  startDate: string | null,
  endDate: string | null,
  sortKey: string | null,
  sortDirection: number | null,
  searchString: string | null,
  measurementTypes: string | null
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/Report/UserReadingsXls/${userId}?`;
  if (endDate !== null) URL += `&startDate=${startDate}&endDate=${endDate}`;
  if (searchString !== null) URL += `&searchString=${searchString}`;
  if (sortKey !== null)
    URL += `&sortKey=${sortKey}&sortDirection=${sortDirection}`;
  if (measurementTypes !== null && measurementTypes !== "")
    URL += `&measurementTypes=${measurementTypes}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchAllDashboardItems = (loggedInUser: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/provider/dashboardcomponents`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchProviderDashboardItems = (
  loggedInUser: any,
  groupId: string
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //console.log(groupId);
  let URL = `${URL_LOCATION}/api/provider/dashboardcomponents/${groupId}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchUserDashboardItems = (loggedInUser: any, userId: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/provider/dashboardcomponents/${userId}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const fetchRewardsCount = (
  loggedInUser: any,
  groupId: string,
  count: any
) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  let URL = `${URL_LOCATION}/api/provider/rewards/${groupId}?`;
  if (count !== null) URL += `&count=${count}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    //
    return response.data;
  });
};

export const sendApprovedProviderCodeNotification = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/notification/sendNotificationForApprovedProviderCode`;

  return axios({
    url: URL,
    method: "post",
    data: data
  }).then((response) => {
    return response;
  });
};

export const sendNotification = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/notification/sendNotification`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const deleteNotification = (props: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/notification/deleteSchedule`;
  return axios({
    url: URL,
    method: "delete",
    data: data
  }).then((response) => {
    return response;
  });
};

export const deleteSingleNotification = (props: any, data: any, jobID: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/notification/deleteSingleSchedule/${jobID}`;
  return axios({
    url: URL,
    method: "delete",
    data: data
  }).then((response) => {
    return response;
  });
};

export const getSchedules = (props: any, provider: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/notification/getSchedules/${data?.data?.id}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}
export const getScheduledRuleNotifications = (props: any, provider: any, pageSize: number, pageNum: number) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/notification/getScheduldRule/${provider}?page=` + pageNum + `&pageSize=` + pageSize;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getScheduledNotificationsByUserId = (props: any, userId: any, providerName: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/notification/getScheduleByUserId/${userId}/${providerName}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getPendingNotifications = (props: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken} `
  );
  const URL = `${URL_LOCATION}/api/notification/getPendingSchedules`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getCompletedNotifications = (props: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };
  const jwtDecoded: any = getDecodedToken(
    `${props.signInUserSession.accessToken.jwtToken} `
  );
  const URL = `${URL_LOCATION}/api/notification/getCompletedSchedules/${props.username}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getfileManager = async (props: any, fileName: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
    "Accept": '*/*'
  };

  const URL = `${URL_LOCATION}/api/filemanager/sharefile/?fileName=${fileName}`;

  const response = await axios({
    url: URL,
    method: "get",
  });
  return response;
}

export const createSurvey = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/surveyForm/save`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const createApprovedSurvey = (user: any, data: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/surveyForm/SaveApprovedSurvey/${id}`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const createSurveyResults = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user} `,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/surveyForm/saveSurveyResults`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const surveyResponseSentimentAnalyze = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user} `,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/surveyForm/sentimentAnalyze`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const updateSurvey = (user: any, data: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/EditSurvey/${id}`;

  return axios({
    url: URL,
    method: "put",
    data: data
  }).then((response) => {
    return response;
  });
};

export const updateTitleForSurvey = (user: any, data: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/EditTitle/${id}`;

  return axios({
    url: URL,
    method: "put",
    data: data
  }).then((response) => {
    return response;
  });
};

export const updateSurveyStatusToReject = (user: any, data: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/UpdateToRejectSurvey/${id}`;

  return axios({
    url: URL,
    method: "put",
    data: data
  }).then((response) => {
    return response;
  });
};

export const deleteSurvey = (user: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/deleteSurvey/${id}`;

  return axios({
    url: URL,
    method: 'delete',
  }).then((response) => {
    return response;
  });
};

export const deleteTempSurvey = (user: any, id: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken} `,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/deleteTempSurvey/${id}`;

  return axios({
    url: URL,
    method: 'delete',
  }).then((response) => {
    return response;
  });
};

export const getSurveysByid = (user: any, id: any, status: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user} `,
    "Access-Control-Allow-Origin": "",
  };

  const URL = `${URL_LOCATION}/api/surveyForm/getSurveyById/${id}/${status}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getSurveys = (user: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/surveyForm/getSurveys/${provider}/${user.username}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getSurveySentiment = (user: any, question: string, answer: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };

  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );

  const URL = `${URL_LOCATION}/api/surveyForm/getSurveyResponseSentiment?question=${encodeURIComponent(
    question
  )}&answer=${encodeURIComponent(answer)}`;

  return axios.get(URL).then((response) => {
    return response.data;
  });
};

export const getSurveyResultById = (user: any, surveyId: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/surveyForm/getSurveyResultById/${surveyId}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getSurveyResultByUsers = (user: any, surveyId: any) => {

  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/surveyForm/getSurveyResultByUsers/${surveyId}`;

  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  }).catch(err => console.log('getSurveyResultByUsers err', err))
}

export const getSurveyResultByUserId = (user: any, userId: any, providerid: any) => {

  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/surveyForm/getSurveyResultByUserId/${userId}/${providerid}`;

  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  }).catch(err => console.log('getSurveyResultByUsers err', err))
}

export const createGroups = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/group/createGroups`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const addGroupusers = (user: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data"
  };
  const URL = `${URL_LOCATION}/api/group/addGroupUsers`;
  return axios({
    url: URL,
    method: "post",
    data: data,
  }).then((response) => {
    return response;
  });
};

export const getProviderGroups = (user: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/group/getProviderGroups/${provider}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const deleteProviderGroup = (props: any, data: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/group/deleteGroups`
  return axios({
    url: URL,
    method: "delete",
    data: data
  }).then((response) => {
    return response;
  });
};

export const deleteGroupUser = (props: any, data: any, provider: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${props.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/group/deleteGroupUser/${provider}`
  return axios({
    url: URL,
    method: "delete",
    data: data
  }).then((response) => {
    return response;
  });
};

export const FileManagerURL = {
  AzureFileOperations: URL_LOCATION + "/api/FileManager/AzureFileOperations",
  AzureGetImage: URL_LOCATION + "/api/FileManager/AzureGetImage",
  AzureUpload: URL_LOCATION + "/api/FileManager/AzureUpload",
  AzureDownload: URL_LOCATION + "/api/FileManager/AzureDownload",
}

export const fetchEMRApprovedData = (loggedInUser: any, userId: string, providerId: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };

  const URL = `${URL_LOCATION}/api/user/emrrecord/${userId}`;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};


export const fetchEMRTempData = (loggedInUser: any, userId: string, providerId: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedToken(`${loggedInUser.signInUserSession.accessToken.jwtToken}`) ;
  const URL = `${URL_LOCATION}/api/integration/epicsearch/provider/${providerId}/patient/${userId}`;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};


export const updateUserEMRData = (loggedInUser: any, user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/integration/updateuseremrrecord`;

  return axios({
    url: URL,
    method: "put",
    data: user
  }).then((response) => {
    return response;
  });
};


export const fetchPendingUsers = (loggedInUser: any, groupId: string) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  //const jwtDecoded :any = getDecodedToken(`${loggedInUser.signInUserSession.accessToken.jwtToken}`) ;
  const URL = `${URL_LOCATION}/api/user/pendingusers/?groupcode=${groupId}`;
  return axios({
    url: URL,
    method: "get",
  })
    .then((response) => {
      //
      return response.data;
    })
    .catch((err) => {
      throw new Error(err.response.data.Message);
    });
};


export const approvePendingUser = (loggedInUser: any, user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/user/updatependinguser`;

  return axios({
    url: URL,
    method: "put",
    data: user
  }).then((response) => {
    return response;
  });
};

export const rejectPendingUser = (loggedInUser: any, user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${loggedInUser.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  const URL = `${URL_LOCATION}/api/user/rejectpendinguser`;

  return axios({
    url: URL,
    method: "put",
    data: user
  }).then((response) => {
    return response;
  });
};

export const getAllRoles = (user: any) => {
  axios.defaults.headers.common = {
    Authorization: `bearer ${user.signInUserSession.accessToken.jwtToken}`,
    "Access-Control-Allow-Origin": "",
  };
  const jwtDecoded: any = getDecodedToken(
    `${user.signInUserSession.accessToken.jwtToken}`
  );
  const URL = `${URL_LOCATION}/api/role/roles`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const getTenoviGatewayInfo = (gatewayid: any) => {

  const URL = `${URL_LOCATION}/api/tenovi/gatewayInfo/${gatewayid}`;
  return axios({
    url: URL,
    method: "get",
  }).then((response) => {
    return response.data;
  });
}

export const createTenoviUsers = (user: any) => {

  const token = 'eyJraWQiOiIwM09ZbjFiV2VLNzRKcENoSVhVVkxWOHlVcEdBY3VKTHZjdlwvcWtSUlFlbz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJmMjNkMjI4Yy1jNmU3LTQwYmItYjhhMS04YjZhNWQ2OTkwM2QiLCJjb2duaXRvOmdyb3VwcyI6WyJDUFJPViJdLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0yLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMl92cXZnQXhnamsiLCJjbGllbnRfaWQiOiJlbW85MjEyYW1panNjYTM2bGYzdmtyanRuIiwib3JpZ2luX2p0aSI6IjY4NWVjY2MyLTQwMzYtNDIxYi1hYzZiLTk5MjFiZDIwMWExMiIsImV2ZW50X2lkIjoiMWUyN2NjZTctMjBiOS00YjE2LWE1ODUtZDAzMDAwOTc4ZGNiIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc2OTAyMjM0NCwiZXhwIjoxNzY5MDI5NTQ0LCJpYXQiOjE3NjkwMjIzNDQsImp0aSI6IjRlMDUyYTI2LWY1ODktNDE0Yy1iNDgwLTU5ZmUyYjM0N2UwNiIsInVzZXJuYW1lIjoiZjIzZDIyOGMtYzZlNy00MGJiLWI4YTEtOGI2YTVkNjk5MDNkIn0.c4nfrMhFGeWA5xOj4YGQJIY01Z3QTNTYOO4G6zqcgFtvMBGEjjSCT8e0RvqWXdYFLiyO92ca_wCrzz2dNuLsCUnTkKLS8B9GgAwH54zFuKwiEHZ-YUgGjh29WXSRJ-3Q3SkjW8NaGVCzRHtKDFPds82b9dRoeEIleZPsQ8dJ4fanC72Wy5wW9qYnKkPm1i2CtA8NusIK05f0pCqsQNoDgPZ4SCptzs4m_2owz9n8vPKV4o0yl70zKKRZApN-r7UZEiPSioLjsWw9TvPCQNp4VdcxoQM4tjhEKyxOSQlIuNo2r5sYp6pBkIGvFk1MW4NaSbJsi7L-qwKI6hy2D9duYA'

  axios.defaults.headers.common = {
    // Authorization: `bearer ${token}`,
    'Content-Type': 'application/json',
    // "Access-Control-Allow-Origin": "*"
  };

  // const URL = `https://api2.tenovi.com/clients/medline-testdemo/hwi/hwi-devices/`;
  const URL = `${URL_LOCATION}/api/tenovi/createTenoviUsers`;

  return axios({
    url: URL,
    method: "post",
    data: user,
  }).then((response) => {
    return response;
  }).catch((err) => {
    throw err;
  })
}
